/* Copyright (C) 2016 NooBaa */

export default {
    type: 'string'
};
